import { render, staticRenderFns } from "./RouteManage.vue?vue&type=template&id=bd779ecc&scoped=true&"
import script from "./RouteManage.vue?vue&type=script&lang=js&"
export * from "./RouteManage.vue?vue&type=script&lang=js&"
import style0 from "./RouteManage.vue?vue&type=style&index=0&id=bd779ecc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd779ecc",
  null
  
)

export default component.exports